import { render, staticRenderFns } from "./RoleAddDialog.vue?vue&type=template&id=489055b4&scoped=true"
import script from "./RoleAddDialog.vue?vue&type=script&lang=js"
export * from "./RoleAddDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleAddDialog.vue?vue&type=style&index=0&id=489055b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489055b4",
  null
  
)

export default component.exports